const Color = {
  text: '#f1f2f6',
  background: '#000',
  gray: '#ced6e0',
  link: '#1e90ff',
};

export default Color;
